// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kore-chat-window .date-picker {
  width: 170px;
  height: 25px;
  padding: 0;
  border: 0;
  line-height: 25px;
  padding-left: 10px;
  font-size: 12px;
  font-family: Arial, sans-serif;
  font-weight: bold;
  cursor: pointer;
  color: #303030;
  position: relative;
  z-index: 2;
}

.kore-chat-window .date-picker-wrapper {
  position: absolute;
  z-index: 1;
  border: 1px solid #bfbfbf;
  background-color: #efefef;
  padding: 5px 12px;
  font-size: 12px;
  line-height: 20px;
  color: #aaa;
  font-family: Arial, sans-serif;
  -webkit-box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.5);
  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.5);
  -webkit-box-sizing: initial;
  box-sizing: initial;
}

.kore-chat-window .dp-clearfix {
  clear: both;
  height: 0;
  font-size: 0;
}

.kore-chat-window .date-picker-wrapper.inline-wrapper {
  position: relative;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: inline-block;
}

.kore-chat-window .date-picker-wrapper.single-date {
  width: auto;
}

.kore-chat-window .date-picker-wrapper.no-shortcuts {
  padding-bottom: 12px;
}

.kore-chat-window .date-picker-wrapper.no-topbar {
  padding-top: 12px;
}

.kore-chat-window .date-picker-wrapper .footer {
  font-size: 11px;
  padding-top: 3px;
}

.kore-chat-window .date-picker-wrapper b {
  color: #666;
  font-weight: 700;
}

.kore-chat-window .date-picker-wrapper a {
  color: #6bb4d6;
  text-decoration: underline;
}

.kore-chat-window .date-picker-wrapper .month-name {
  text-transform: uppercase;
}

.kore-chat-window .date-picker-wrapper .select-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
}

.kore-chat-window .date-picker-wrapper .select-wrapper:hover {
  text-decoration: underline;
}

.kore-chat-window .date-picker-wrapper .month-element {
  display: inline-block;
  vertical-align: middle;
}

.kore-chat-window .date-picker-wrapper .select-wrapper select {
  position: absolute;
  margin: 0;
  padding: 0;
  left: 0;
  top: -1px;
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
  text-transform: inherit;
  color: inherit;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: transparent;
  border: 0;
  outline: 0;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=1)";
  filter: alpha(opacity=1);
  opacity: 0.01;
}

.kore-chat-window .date-picker-wrapper .month-wrapper {
  border: 1px solid #bfbfbf;
  border-radius: 3px;
  background-color: #fff;
  padding: 5px;
  cursor: default;
  position: relative;
  _overflow: hidden;
}

.kore-chat-window .date-picker-wrapper .month-wrapper table {
  width: 190px;
  float: left;
}

.kore-chat-window .date-picker-wrapper .month-wrapper table.month2 {
  width: 190px;
  float: left;
}

.kore-chat-window .date-picker-wrapper .month-wrapper table th, .kore-chat-window .date-picker-wrapper .month-wrapper table td {
  vertical-align: middle;
  text-align: center;
  line-height: 14px;
  margin: 0px;
  padding: 0px;
}

.kore-chat-window .date-picker-wrapper .month-wrapper table .day {
  padding: 5px 0;
  line-height: 1;
  font-size: 12px;
  margin-bottom: 1px;
  color: #ccc;
  cursor: default;
}

.kore-chat-window .date-picker-wrapper .month-wrapper table div.day.lastMonth, .kore-chat-window .date-picker-wrapper .month-wrapper table div.day.nextMonth {
  color: #999;
  cursor: default;
}

.kore-chat-window .date-picker-wrapper .month-wrapper table .day.checked {
  background-color: #9cdbf7;
}

.kore-chat-window .date-picker-wrapper .month-wrapper table .week-name {
  height: 20px;
  line-height: 20px;
  font-weight: 100;
  text-transform: uppercase;
}

.kore-chat-window .date-picker-wrapper .month-wrapper table .day.has-tooltip {
  cursor: help !important;
}

.kore-chat-window .date-picker-wrapper .month-wrapper table .day.has-tooltip .tooltip {
  white-space: nowrap;
}

.kore-chat-window .date-picker-wrapper .time label {
  white-space: nowrap;
}

.kore-chat-window .date-picker-wrapper .month-wrapper table .day.toMonth.valid {
  color: #333;
  cursor: pointer;
}

.kore-chat-window .date-picker-wrapper .month-wrapper table .day.toMonth.hovering {
  background-color: #cdecfa;
}

.kore-chat-window .date-picker-wrapper .month-wrapper table .day.nextMonth, .kore-chat-window .date-picker-wrapper .month-wrapper table .day.lastMonth {
  display: none;
}

.kore-chat-window .date-picker-wrapper .month-wrapper table .day.real-today {
  background-color: #ffe684;
}

.kore-chat-window .date-picker-wrapper .month-wrapper table .day.real-today.checked, .kore-chat-window .date-picker-wrapper .month-wrapper table .day.real-today.hovering {
  background-color: #70ccd5;
}

.kore-chat-window .date-picker-wrapper table .caption {
  height: 40px;
}

.kore-chat-window .date-picker-wrapper table .caption > th:first-of-type, .kore-chat-window .date-picker-wrapper table .caption > th:last-of-type {
  width: 27px;
}

.kore-chat-window .date-picker-wrapper table .caption .next, .kore-chat-window .date-picker-wrapper table .caption .prev {
  padding: 0 5px;
  cursor: pointer;
}

.kore-chat-window .date-picker-wrapper table .caption .next:hover, .kore-chat-window .date-picker-wrapper table .caption .prev:hover {
  background-color: #ccc;
  color: white;
}

.kore-chat-window .date-picker-wrapper .gap {
  position: relative;
  z-index: 1;
  width: 15px;
  height: 100%;
  background-color: red;
  font-size: 0;
  line-height: 0;
  float: left;
  top: -5px;
  margin: 0 10px -10px;
  visibility: hidden;
  height: 0;
}

.kore-chat-window .date-picker-wrapper .gap .gap-lines {
  height: 100%;
  overflow: hidden;
}

.kore-chat-window .date-picker-wrapper .gap .gap-line {
  height: 15px;
  width: 15px;
  position: relative;
}

.kore-chat-window .date-picker-wrapper .gap .gap-line .gap-1 {
  z-index: 1;
  height: 0;
  border-left: 8px solid white;
  border-top: 8px solid #eee;
  border-bottom: 8px solid #eee;
}

.kore-chat-window .date-picker-wrapper .gap .gap-line .gap-2 {
  position: absolute;
  right: 0;
  top: 0px;
  z-index: 2;
  height: 0;
  border-left: 8px solid transparent;
  border-top: 8px solid white;
}

.kore-chat-window .date-picker-wrapper .gap .gap-line .gap-3 {
  position: absolute;
  right: 0;
  top: 8px;
  z-index: 2;
  height: 0;
  border-left: 8px solid transparent;
  border-bottom: 8px solid white;
}

.kore-chat-window .date-picker-wrapper .gap .gap-top-mask {
  width: 6px;
  height: 1px;
  position: absolute;
  top: -1px;
  left: 1px;
  background-color: #eee;
  z-index: 3;
}

.kore-chat-window .date-picker-wrapper .gap .gap-bottom-mask {
  width: 6px;
  height: 1px;
  position: absolute;
  bottom: -1px;
  left: 7px;
  background-color: #eee;
  z-index: 3;
}

.kore-chat-window .date-picker-wrapper .selected-days {
  display: none;
}

.kore-chat-window .date-picker-wrapper .drp_top-bar {
  line-height: 1.4;
  position: relative;
  padding: 10px 40px 10px 0;
}

.kore-chat-window .date-picker-wrapper .drp_top-bar .error-top, .kore-chat-window .date-picker-wrapper .drp_top-bar .normal-top {
  display: none;
}

.kore-chat-window .date-picker-wrapper .drp_top-bar .default-top {
  display: block;
}

.kore-chat-window .date-picker-wrapper .drp_top-bar.error .default-top {
  display: none;
}

.kore-chat-window .date-picker-wrapper .drp_top-bar.error .error-top {
  display: block;
  color: red;
}

.kore-chat-window .date-picker-wrapper .drp_top-bar.normal .default-top {
  display: none;
}

.kore-chat-window .date-picker-wrapper .drp_top-bar.normal .normal-top {
  display: block;
}

.kore-chat-window .date-picker-wrapper .drp_top-bar.normal .normal-top .selection-top {
  color: #333;
}

.kore-chat-window .date-picker-wrapper .drp_top-bar .apply-btn {
  position: absolute;
  right: 0px;
  top: 6px;
  padding: 3px 5px;
  margin: 0;
  font-size: 12px;
  border-radius: 4px;
  cursor: pointer;
  color: #d9eef7;
  border: solid 1px #0076a3;
  background: #0095cd;
  background: -moz-linear-gradient(top, #00adee, #0078a5);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00adee', endColorstr='#0078a5');
  color: white;
  line-height: initial;
}

.kore-chat-window .date-picker-wrapper .drp_top-bar .apply-btn.disabled {
  cursor: pointer;
  color: #606060;
  border: solid 1px #b7b7b7;
  background: #fff;
  background: -moz-linear-gradient(top, #fff, #ededed);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#ededed');
}

.kore-chat-window .date-picker-wrapper .time {
  position: relative;
}

.kore-chat-window .date-picker-wrapper.single-month .time {
  display: block;
}

.kore-chat-window .date-picker-wrapper .time input[type=range] {
  vertical-align: middle;
  width: 129px;
  padding: 0;
  margin: 0;
  height: 20px;
}

.kore-chat-window .date-picker-wrapper .time1 {
  width: 180px;
  padding: 0 5px;
  text-align: center;
}

/*time styling*/
.kore-chat-window .date-picker-wrapper .time2 {
  width: 180px;
  padding: 0 5px;
  text-align: center;
}

.kore-chat-window .date-picker-wrapper .time1 {
  float: left;
}

.kore-chat-window .date-picker-wrapper .time2 {
  float: right;
}

.kore-chat-window .date-picker-wrapper .hour {
  text-align: right;
}

.kore-chat-window .date-picker-wrapper .minute {
  text-align: right;
}

.kore-chat-window .date-picker-wrapper .hide {
  display: none;
}

.kore-chat-window .date-picker-wrapper .first-date-selected, .kore-chat-window .date-picker-wrapper .last-date-selected {
  background-color: #49e !important;
  color: white !important;
}

.kore-chat-window .date-picker-wrapper .date-range-length-tip {
  position: absolute;
  margin-top: -4px;
  margin-left: -8px;
  -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  display: none;
  background-color: yellow;
  padding: 0 6px;
  border-radius: 2px;
  font-size: 12px;
  line-height: 16px;
  -webkit-filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.3));
  -moz-filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.3));
  -ms-filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.3));
  -o-filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.3));
  filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.3));
}

.kore-chat-window .date-picker-wrapper .date-range-length-tip:after {
  content: "";
  position: absolute;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid yellow;
  left: 50%;
  margin-left: -4px;
  bottom: -4px;
}

.kore-chat-window .date-picker-wrapper.two-months.no-gap .month1 .next, .kore-chat-window .date-picker-wrapper.two-months.no-gap .month2 .prev {
  display: none;
}

.kore-chat-window .date-picker-wrapper .week-number {
  padding: 5px 0;
  line-height: 1;
  font-size: 12px;
  margin-bottom: 1px;
  color: #999;
  cursor: pointer;
}

.kore-chat-window .date-picker-wrapper .week-number.week-number-selected {
  color: #49e;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/libs/jquery-daterangepicker/daterangepicker.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,8BAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,8BAAA;EACA,mDAAA;EACQ,2CAAA;EACR,2BAAA;EACQ,mBAAA;AACV;;AAEA;EACE,WAAA;EACA,SAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,wBAAA;EACQ,gBAAA;EACR,qBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,0BAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,qBAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,OAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;EACA,gEAAA;EACA,wBAAA;EACA,aAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;GACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,UAAA;EACA,SAAA;EACA,4BAAA;EACA,0BAAA;EACA,6BAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,kCAAA;EACA,2BAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,kCAAA;EACA,8BAAA;AACF;;AAEA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,sBAAA;EACA,UAAA;AACF;;AAEA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,sBAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,cAAA;EACA,UAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,uDAAA;EACA,kGAAA;EACA,YAAA;EACA,oBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,oDAAA;EACA,kGAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,sBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA,eAAA;AACA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,iCAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,8CAAA;EACQ,sCAAA;EACR,aAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,uDAAA;EACA,oDAAA;EACA,mDAAA;EACA,kDAAA;EACA,+CAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,kCAAA;EACA,mCAAA;EACA,4BAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,iBAAA;AACF","sourcesContent":[".kore-chat-window .date-picker {\n  width: 170px;\n  height: 25px;\n  padding: 0;\n  border: 0;\n  line-height: 25px;\n  padding-left: 10px;\n  font-size: 12px;\n  font-family: Arial, sans-serif;\n  font-weight: bold;\n  cursor: pointer;\n  color: #303030;\n  position: relative;\n  z-index: 2;\n}\n\n.kore-chat-window .date-picker-wrapper {\n  position: absolute;\n  z-index: 1;\n  border: 1px solid #bfbfbf;\n  background-color: #efefef;\n  padding: 5px 12px;\n  font-size: 12px;\n  line-height: 20px;\n  color: #aaa;\n  font-family: Arial, sans-serif;\n  -webkit-box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.5);\n          box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.5);\n  -webkit-box-sizing: initial;\n          box-sizing: initial;\n}\n\n.kore-chat-window .dp-clearfix {\n  clear: both;\n  height: 0;\n  font-size: 0;\n}\n\n.kore-chat-window .date-picker-wrapper.inline-wrapper {\n  position: relative;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  display: inline-block;\n}\n\n.kore-chat-window .date-picker-wrapper.single-date {\n  width: auto;\n}\n\n.kore-chat-window .date-picker-wrapper.no-shortcuts {\n  padding-bottom: 12px;\n}\n\n.kore-chat-window .date-picker-wrapper.no-topbar {\n  padding-top: 12px;\n}\n\n.kore-chat-window .date-picker-wrapper .footer {\n  font-size: 11px;\n  padding-top: 3px;\n}\n\n.kore-chat-window .date-picker-wrapper b {\n  color: #666;\n  font-weight: 700;\n}\n\n.kore-chat-window .date-picker-wrapper a {\n  color: #6bb4d6;\n  text-decoration: underline;\n}\n\n.kore-chat-window .date-picker-wrapper .month-name {\n  text-transform: uppercase;\n}\n\n.kore-chat-window .date-picker-wrapper .select-wrapper {\n  position: relative;\n  overflow: hidden;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.kore-chat-window .date-picker-wrapper .select-wrapper:hover {\n  text-decoration: underline;\n}\n\n.kore-chat-window .date-picker-wrapper .month-element {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.kore-chat-window .date-picker-wrapper .select-wrapper select {\n  position: absolute;\n  margin: 0;\n  padding: 0;\n  left: 0;\n  top: -1px;\n  font-size: inherit;\n  font-style: inherit;\n  font-weight: inherit;\n  text-transform: inherit;\n  color: inherit;\n  cursor: pointer;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background: transparent;\n  border: 0;\n  outline: 0;\n  -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=1)\";\n  filter: alpha(opacity=1);\n  opacity: 0.01;\n}\n\n.kore-chat-window .date-picker-wrapper .month-wrapper {\n  border: 1px solid #bfbfbf;\n  border-radius: 3px;\n  background-color: #fff;\n  padding: 5px;\n  cursor: default;\n  position: relative;\n  _overflow: hidden;\n}\n\n.kore-chat-window .date-picker-wrapper .month-wrapper table {\n  width: 190px;\n  float: left;\n}\n\n.kore-chat-window .date-picker-wrapper .month-wrapper table.month2 {\n  width: 190px;\n  float: left;\n}\n\n.kore-chat-window .date-picker-wrapper .month-wrapper table th, .kore-chat-window .date-picker-wrapper .month-wrapper table td {\n  vertical-align: middle;\n  text-align: center;\n  line-height: 14px;\n  margin: 0px;\n  padding: 0px;\n}\n\n.kore-chat-window .date-picker-wrapper .month-wrapper table .day {\n  padding: 5px 0;\n  line-height: 1;\n  font-size: 12px;\n  margin-bottom: 1px;\n  color: #ccc;\n  cursor: default;\n}\n\n.kore-chat-window .date-picker-wrapper .month-wrapper table div.day.lastMonth, .kore-chat-window .date-picker-wrapper .month-wrapper table div.day.nextMonth {\n  color: #999;\n  cursor: default;\n}\n\n.kore-chat-window .date-picker-wrapper .month-wrapper table .day.checked {\n  background-color: #9cdbf7;\n}\n\n.kore-chat-window .date-picker-wrapper .month-wrapper table .week-name {\n  height: 20px;\n  line-height: 20px;\n  font-weight: 100;\n  text-transform: uppercase;\n}\n\n.kore-chat-window .date-picker-wrapper .month-wrapper table .day.has-tooltip {\n  cursor: help !important;\n}\n\n.kore-chat-window .date-picker-wrapper .month-wrapper table .day.has-tooltip .tooltip {\n  white-space: nowrap;\n}\n\n.kore-chat-window .date-picker-wrapper .time label {\n  white-space: nowrap;\n}\n\n.kore-chat-window .date-picker-wrapper .month-wrapper table .day.toMonth.valid {\n  color: #333;\n  cursor: pointer;\n}\n\n.kore-chat-window .date-picker-wrapper .month-wrapper table .day.toMonth.hovering {\n  background-color: #cdecfa;\n}\n\n.kore-chat-window .date-picker-wrapper .month-wrapper table .day.nextMonth, .kore-chat-window .date-picker-wrapper .month-wrapper table .day.lastMonth {\n  display: none;\n}\n\n.kore-chat-window .date-picker-wrapper .month-wrapper table .day.real-today {\n  background-color: #ffe684;\n}\n\n.kore-chat-window .date-picker-wrapper .month-wrapper table .day.real-today.checked, .kore-chat-window .date-picker-wrapper .month-wrapper table .day.real-today.hovering {\n  background-color: #70ccd5;\n}\n\n.kore-chat-window .date-picker-wrapper table .caption {\n  height: 40px;\n}\n\n.kore-chat-window .date-picker-wrapper table .caption > th:first-of-type, .kore-chat-window .date-picker-wrapper table .caption > th:last-of-type {\n  width: 27px;\n}\n\n.kore-chat-window .date-picker-wrapper table .caption .next, .kore-chat-window .date-picker-wrapper table .caption .prev {\n  padding: 0 5px;\n  cursor: pointer;\n}\n\n.kore-chat-window .date-picker-wrapper table .caption .next:hover, .kore-chat-window .date-picker-wrapper table .caption .prev:hover {\n  background-color: #ccc;\n  color: white;\n}\n\n.kore-chat-window .date-picker-wrapper .gap {\n  position: relative;\n  z-index: 1;\n  width: 15px;\n  height: 100%;\n  background-color: red;\n  font-size: 0;\n  line-height: 0;\n  float: left;\n  top: -5px;\n  margin: 0 10px -10px;\n  visibility: hidden;\n  height: 0;\n}\n\n.kore-chat-window .date-picker-wrapper .gap .gap-lines {\n  height: 100%;\n  overflow: hidden;\n}\n\n.kore-chat-window .date-picker-wrapper .gap .gap-line {\n  height: 15px;\n  width: 15px;\n  position: relative;\n}\n\n.kore-chat-window .date-picker-wrapper .gap .gap-line .gap-1 {\n  z-index: 1;\n  height: 0;\n  border-left: 8px solid white;\n  border-top: 8px solid #eee;\n  border-bottom: 8px solid #eee;\n}\n\n.kore-chat-window .date-picker-wrapper .gap .gap-line .gap-2 {\n  position: absolute;\n  right: 0;\n  top: 0px;\n  z-index: 2;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-top: 8px solid white;\n}\n\n.kore-chat-window .date-picker-wrapper .gap .gap-line .gap-3 {\n  position: absolute;\n  right: 0;\n  top: 8px;\n  z-index: 2;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-bottom: 8px solid white;\n}\n\n.kore-chat-window .date-picker-wrapper .gap .gap-top-mask {\n  width: 6px;\n  height: 1px;\n  position: absolute;\n  top: -1px;\n  left: 1px;\n  background-color: #eee;\n  z-index: 3;\n}\n\n.kore-chat-window .date-picker-wrapper .gap .gap-bottom-mask {\n  width: 6px;\n  height: 1px;\n  position: absolute;\n  bottom: -1px;\n  left: 7px;\n  background-color: #eee;\n  z-index: 3;\n}\n\n.kore-chat-window .date-picker-wrapper .selected-days {\n  display: none;\n}\n\n.kore-chat-window .date-picker-wrapper .drp_top-bar {\n  line-height: 1.4;\n  position: relative;\n  padding: 10px 40px 10px 0;\n}\n\n.kore-chat-window .date-picker-wrapper .drp_top-bar .error-top, .kore-chat-window .date-picker-wrapper .drp_top-bar .normal-top {\n  display: none;\n}\n\n.kore-chat-window .date-picker-wrapper .drp_top-bar .default-top {\n  display: block;\n}\n\n.kore-chat-window .date-picker-wrapper .drp_top-bar.error .default-top {\n  display: none;\n}\n\n.kore-chat-window .date-picker-wrapper .drp_top-bar.error .error-top {\n  display: block;\n  color: red;\n}\n\n.kore-chat-window .date-picker-wrapper .drp_top-bar.normal .default-top {\n  display: none;\n}\n\n.kore-chat-window .date-picker-wrapper .drp_top-bar.normal .normal-top {\n  display: block;\n}\n\n.kore-chat-window .date-picker-wrapper .drp_top-bar.normal .normal-top .selection-top {\n  color: #333;\n}\n\n.kore-chat-window .date-picker-wrapper .drp_top-bar .apply-btn {\n  position: absolute;\n  right: 0px;\n  top: 6px;\n  padding: 3px 5px;\n  margin: 0;\n  font-size: 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  color: #d9eef7;\n  border: solid 1px #0076a3;\n  background: #0095cd;\n  background: -moz-linear-gradient(top, #00adee, #0078a5);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00adee', endColorstr='#0078a5');\n  color: white;\n  line-height: initial;\n}\n\n.kore-chat-window .date-picker-wrapper .drp_top-bar .apply-btn.disabled {\n  cursor: pointer;\n  color: #606060;\n  border: solid 1px #b7b7b7;\n  background: #fff;\n  background: -moz-linear-gradient(top, #fff, #ededed);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#ededed');\n}\n\n.kore-chat-window .date-picker-wrapper .time {\n  position: relative;\n}\n\n.kore-chat-window .date-picker-wrapper.single-month .time {\n  display: block;\n}\n\n.kore-chat-window .date-picker-wrapper .time input[type=range] {\n  vertical-align: middle;\n  width: 129px;\n  padding: 0;\n  margin: 0;\n  height: 20px;\n}\n\n.kore-chat-window .date-picker-wrapper .time1 {\n  width: 180px;\n  padding: 0 5px;\n  text-align: center;\n}\n\n/*time styling*/\n.kore-chat-window .date-picker-wrapper .time2 {\n  width: 180px;\n  padding: 0 5px;\n  text-align: center;\n}\n\n.kore-chat-window .date-picker-wrapper .time1 {\n  float: left;\n}\n\n.kore-chat-window .date-picker-wrapper .time2 {\n  float: right;\n}\n\n.kore-chat-window .date-picker-wrapper .hour {\n  text-align: right;\n}\n\n.kore-chat-window .date-picker-wrapper .minute {\n  text-align: right;\n}\n\n.kore-chat-window .date-picker-wrapper .hide {\n  display: none;\n}\n\n.kore-chat-window .date-picker-wrapper .first-date-selected, .kore-chat-window .date-picker-wrapper .last-date-selected {\n  background-color: #49e !important;\n  color: white !important;\n}\n\n.kore-chat-window .date-picker-wrapper .date-range-length-tip {\n  position: absolute;\n  margin-top: -4px;\n  margin-left: -8px;\n  -webkit-box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);\n          box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);\n  display: none;\n  background-color: yellow;\n  padding: 0 6px;\n  border-radius: 2px;\n  font-size: 12px;\n  line-height: 16px;\n  -webkit-filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.3));\n  -moz-filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.3));\n  -ms-filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.3));\n  -o-filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.3));\n  filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.3));\n}\n\n.kore-chat-window .date-picker-wrapper .date-range-length-tip:after {\n  content: '';\n  position: absolute;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid yellow;\n  left: 50%;\n  margin-left: -4px;\n  bottom: -4px;\n}\n\n.kore-chat-window .date-picker-wrapper.two-months.no-gap .month1 .next, .kore-chat-window .date-picker-wrapper.two-months.no-gap .month2 .prev {\n  display: none;\n}\n\n.kore-chat-window .date-picker-wrapper .week-number {\n  padding: 5px 0;\n  line-height: 1;\n  font-size: 12px;\n  margin-bottom: 1px;\n  color: #999;\n  cursor: pointer;\n}\n\n.kore-chat-window .date-picker-wrapper .week-number.week-number-selected {\n  color: #49e;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
